import { render, staticRenderFns } from "./PhaseEarning.vue?vue&type=template&id=58596c2a"
import script from "./PhaseEarning.vue?vue&type=script&lang=js"
export * from "./PhaseEarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports